import styled from 'styled-components';
import {
  whiteColor,
  infoColor,
  grayColor,
} from '~/components/layout/Variables';
import MaskedInput from 'react-input-mask';

export const Background = styled.section`
  height: auto;
  padding: 0 30px;
  background: ${() => whiteColor};
  @media (max-width: 768px) {
    padding: 0 0px;
  }
`;

export const MainContainer = styled.div`
  margin: 0 1.5rem;
`;

export const Title = styled.h2`
  font-size: 1.1rem;
  color: ${() => grayColor};
  text-align: center;
  margin: 20px 0;

  img,
  svg {
    margin-right: 10px;
  }

  @media (min-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const SubTitle = styled.p`
  font-size: 0.95rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;
`;

export const AccordionDivision = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Product = styled.span`
  font-size: 1.1rem;
  color: ${() => infoColor};
`;

export const Quantity = styled.span`
  font-size: 1.1rem;
  color: ${() => grayColor};
  margin-right: 0.5rem;
`;

export const InputQuantity = styled.input`
  font-size: 1.5rem;
  text-align: center;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  width: 100%;
`;

export const TextQuantity = styled(SubTitle)`
  text-align: center;
`;

export const SelectProduct = styled.button`
  width: ${props => (props.width ? props.width : `100%`)};
  font-size: 1.2rem;
  color: #949494;
  border: 0.6px solid rgba(80, 80, 80, 0.3);
  background-color: #fff;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 0.4rem;
  padding: 0.2rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${props => props.margin};

  span {
    color: #000FFF;
  }
`;

export const AlignDropdownBranch = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const IconProductStyles = {
  display: 'block',
  margin: '0 auto',
};

export const ContainerButton = styled.div`
  margin: 2rem;
`;

export const ItemDivision = styled.div`
  margin: 1.5rem 0;
  box-shadow: 0px 2px 4px #00000033;
  border-radius: 0.5rem;
`;

export const BackIcon = styled.span`
  display: none;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  @media (max-width: 767px) {
    display: flex;
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  position: absolute;
  top: -42px;
  left: auto;
  right: -10px;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  color: #ffffff;
  cursor: pointer;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const LoadingContainer = styled.div`
  width: 20%;
  margin: 70% auto;
`;

export const AlignProducts = styled.div`
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;

  .product {
    margin: 0.5rem 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .align-icon {
    margin: 0.5rem;
  }
`;

export const CardHeader = {
  backgroundColor: 'rgb(230, 223, 223)',
  color: 'rgb(112, 112, 112)',
  fontSize: '.9rem',
  fontWeight: '550',
  padding: '.2rem 1rem',
  borderTopLeftRadius: '.3rem',
  borderTopRightRadius: '.3rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const DivisionQuantityButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;

  .quantity-100 {
    grid-column: 1 / 3;
    margin: -1rem 0.5rem 1rem 0;
  }
`;

export const Textfield = styled.input`
  ::-webkit-input-placeholder {
    color: #888888;
    font-weight: 100;
    font-size: 15px;
  }
  width: 100%;
  height: 47px;
  border-radius: 10px;
  padding: 0 15px;
  border: 0.5px solid ${props => (props.errorCondition ? 'red' : '#888888')};
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000058;
  color: #808080;

  &:disabled {
    background: #ebebeb 0% 0% no-repeat padding-box;
    color: #808080!important;
  }
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: red;
  margin-top: 10px;
  font-weight: 200;
`;

export const Label = styled.label`
  width: 100%;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: -5px;
`;

export const LightLabel = styled.label`
  width: 100%;
  text-align: left;
  font-size: 1.14rem;
  font-weight: 400;
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 5px;
`;

export const NextButton = styled.button`
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 45px;
  background-color: #000FFF;
  border-radius: 10px;
  color: #ffffff;
  margin-top: 5px;
  margin-bottom: 20px;
  border: 0;
  overflow: hidden;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000059;
  border-radius: 10px;
  transition: 0.5s;
  &:hover {
    filter: brightness(90%);
  }
`;

export const CheckBoxScrollList = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 136px;
  overflow: scroll;
  padding-left: 10px;
  margin-left: -10px;
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #333333;
  }
`;

export const CheckBoxList = styled.div`
  position: relative;
  width: 100%;
  padding-left: 10px;
  margin-left: -10px;
  display: grid;
  grid-template-columns: 50% 50%;
  @media (max-width: 768px) {
    grid-template-columns: 100%;
  }
`;

export const PhoneInput = styled(MaskedInput)`
  width: 100%;
  height: 47px;
  border-radius: 10px;
  padding: 0 15px;
  border: 0.5px solid ${props => (props.errorCondition ? 'red' : '#888888')};
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000058;
  &,
  &::-webkit-input-placeholder,
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    color: ${() => grayColor};
    background: #ffffff 0% 0% no-repeat padding-box;
  }

  &:disabled {
    background: #ebebeb 0% 0% no-repeat padding-box;
    color: #808080!important;
  }
`;
